import { IUiDataStorageService } from '../ports/ui-data-storage-service.port'
import { useUiDataStore } from '../infrastructure/script/store/ui-data-store'

const uiDataStoreService = useUiDataStore()
export const useUiDataStorageServiceAdapter = (): IUiDataStorageService => {
	return uiDataStoreService
}
